import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "e78c6466-58a2-49a4-b9e9-41c92a41b73c", content: "High reproducibility", options: {} },
  { id: "1f984d28-fd7c-4a93-9054-ee69be9c9fe5", content: "Well-controlled test conditions", options: {} },
  { id: "5fcd028c-fd4a-4770-a680-c94f0f01c41d", content: "More realism", options: {} },
  { id: "8719fadd-0f71-4fb6-b88a-83cee6400a48", content: "No hardware needed", options: {} },
  { id: "e32bedd0-7ef6-48c3-afc3-1cdf15b779a4", content: "Better immersion in the scene", options: {} },
];

const groups = [
  { id: "9ae45eba-8d9b-4964-9dcc-3c5f5fee213d", content: "VR experiment", options: {} },
  { id: "3714d571-dcb8-4a5c-b059-e88a78262e81", content: "Real experiment", options: {} },
];

export const task: Task = {
  id: "ef60969a-e655-444b-901b-5423a1c053b3",
  solutionType: "group",
  type: "categorizeLabels",
  options: {
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    {
      groupId: "9ae45eba-8d9b-4964-9dcc-3c5f5fee213d",
      itemsId: ["e78c6466-58a2-49a4-b9e9-41c92a41b73c", "1f984d28-fd7c-4a93-9054-ee69be9c9fe5"],
    },
    {
      groupId: "3714d571-dcb8-4a5c-b059-e88a78262e81",
      itemsId: [
        "5fcd028c-fd4a-4770-a680-c94f0f01c41d",
        "8719fadd-0f71-4fb6-b88a-83cee6400a48",
        "e32bedd0-7ef6-48c3-afc3-1cdf15b779a4",
      ],
    },
  ],
};
